import { CircularProgress } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

import { setQuestionLevels } from '../../../redux/reducers/questionLevelsReducer';
import {
  getAllQuesModules,
  getBookingQuestions,
  getBookings,
} from '../../../services/apiService';
import BookingQuestionCard from '../_components/BookingQuestionCard';
import DetailsHeader from '../_components/DetailsHeader';
import OverallRatingCard from '../_components/OverallRatingCard';

export default function SessionDetails(props) {
  const [booking, setBooking] = useState(null);
  const [questions, setQuestions] = useState([]);
  const { ratingTemplateByConceptId } = useSelector(
    (state) => state.questionLevelsReducer
  );
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const init = async () => {
      try {
        const bookingId = props.match.params?.bookingId;
        if (!bookingId) history.replace('/manage-bookings');
        const [bookingResponse, questionsResponse] = await Promise.all([
          getBookings({
            bookingId,
            includeStudent: true,
            includeCoach: true,
            includeSubTopic: true,
          }),
          getBookingQuestions(bookingId),
        ]);
        if (bookingResponse?.items?.length)
          setBooking(bookingResponse.items[0]);
        else throw new Error('Booking not found');
        if (Array.isArray(questionsResponse)) setQuestions(questionsResponse);
      } catch (err) {
        console.error(err);
        toast.error('Failed to fetch booking details!');
      }
    };
    init();
  }, []);

  useEffect(() => {
    const loadQuestionLevels = async () => {
      try {
        const res = await getAllQuesModules();
        dispatch(setQuestionLevels(res));
      } catch (e) {
        console.error(e);
        toast.error('Failed to fetch details!');
      }
    };
    if (!ratingTemplateByConceptId) loadQuestionLevels();
  }, [ratingTemplateByConceptId]);

  return booking && ratingTemplateByConceptId ? (
    <div>
      <h1 className='text-3xl font-semibold tracking-wide'>Detailed Report</h1>
      <DetailsHeader booking={booking} />

      {questions &&
        questions.map((bookingQuestion, index) => (
          <BookingQuestionCard
            bookingQuestion={bookingQuestion}
            ratingTemplate={
              ratingTemplateByConceptId[bookingQuestion.Question.conceptId]
            }
            index={index}
            key={bookingQuestion.Question.id}
          />
        ))}

      {/* Booking Overall Ratings */}
      <OverallRatingCard
        ratingObj={booking.ratingByCoach}
        from='Coach'
        to='Candidate'
      />

      <OverallRatingCard
        ratingObj={booking.ratingByStudent}
        from='Candidate'
        to='Coach'
      />
    </div>
  ) : (
    <div className='flex items-center justify-center text-blue-c1 dark:text-ab-tertiary h-75h mt-20'>
      <CircularProgress color='inherit' />
    </div>
  );
}
